import * as React from "react";
import { styled, Theme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CssBaseline from "@mui/material/CssBaseline";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import logo from "../assets/logo.svg";
import bg from "../assets/background.jpg";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import { HashLink } from "react-router-hash-link";
import Hamburger from "hamburger-react";
import { SOCIAL } from "../constants";
import SocialLinks from "./SocialLinks";
import { useMediaQuery } from "@mui/material";

const drawerWidth = 400;

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-start",
}));

const PersistentDrawerRight = ({ children }: { children: React.ReactNode }) => {
  const isMobile = useMediaQuery("(max-width:450px)");
  const [open, setOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <MuiAppBar
        position="fixed"
        sx={{
          zIndex: (theme: Theme) => theme.zIndex.drawer + 1,
          backgroundImage:
            "linear-gradient(#3eb48980 0%, rgb(62 180 137 / 24%) 30%, rgb(24 41 13 / 0%) 100%)",
          backgroundColor: "rgba(0,0,0,0.3)",
        }}
      >
        <Toolbar>
          <Box className="toolbar-left">
            <Link to="/">
              <img src={logo} alt="logo" className="logo"></img>
            </Link>
            <Box className="logo-text">
              <Link to="/">Rebel Tiger Club</Link>
            </Box>
          </Box>

          <a href={SOCIAL["discord"]} target="_blank" rel="noopener noreferrer">
            <Button variant="outlined" size="large" className="discord-button">
              JOIN DISCORD
            </Button>
          </a>
          <Hamburger toggled={open} toggle={handleDrawerToggle} />
        </Toolbar>
      </MuiAppBar>
      <main
        style={{
          width: "100%",
          height: "100%",
          backgroundImage: `url("${bg}")`,
          backgroundRepeat: "no-repeat",
          backgroundPositionX: "center",
          backgroundSize: isMobile ? "auto 3000px" : "100% 3000px",
        }}
      >
        {children}
      </main>
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
          },
        }}
        PaperProps={{
          sx: {
            backgroundImage: "none",
          },
        }}
        anchor="right"
        open={open}
      >
        <DrawerHeader></DrawerHeader>
        <List>
          {["about", "roadmap", "team", "faq"].map((text) => (
            <ListItem button key={text} style={{ width: "100%" }}>
              <HashLink
                to={"/#" + text}
                style={{ width: "100%" }}
                onClick={() => setOpen(false)}
              >
                <h3 className="menu-item-text">{text}</h3>
              </HashLink>
            </ListItem>
          ))}
        </List>
        <SocialLinks></SocialLinks>
      </Drawer>
    </Box>
  );
};

export default PersistentDrawerRight;
